import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WaterTribeFestTicketSelection } from '../components/WaterTribeFestTicketSelection';
import { WaterTribeFestPrePaymentForm } from '../components/WaterTribeFestPrePaymentForm';
import { UtmCapture } from '../components/UtmCapture';
import { motion } from 'framer-motion';
import { Waves, Heart, GraduationCap, Target, Sparkles, Music, Zap, Users, Calendar, MapPin, CheckCircle2, Flame, MessageCircle, CreditCard, Lock, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { generateOrderNumber } from '../utils/orderNumber';
import { openTranzilaPayment } from '../utils/tranzila';
import { getUtmParams } from '../utils/utmTracking';
const activities = [{
  icon: Waves,
  title: 'חתירות חוויתיות ותחרותיות',
  description: 'מקצים עממיים ותחרותיים לכל הרמות בסאפ, רייס, קיאק וסרפסקי.',
  image: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
}, {
  icon: Heart,
  title: 'חוויות גוף-נפש',
  description: 'יוגה, פילאטיס מחזק ואמבטיית קרח מודרכת להתאוששות',
  image: 'https://cdn.magicpatterns.com/uploads/oRhKrcQ2puhfgDX5hZr1xf/IMG-20250513-WA0010.jpg'
}, {
  icon: GraduationCap,
  title: 'סדנאות חתירה',
  description: 'שיפור טכניקה, הרצאות והדרכות עם המאמנים המובילים בארץ',
  image: 'https://cdn.magicpatterns.com/uploads/o9c53mVsS3VW85WhRtdH5V/IMG-20251017-WA0049.jpg'
}, {
  icon: Target,
  title: 'תכני העשרה',
  description: 'הרצאות השראה, סדנאות ועוד מלא הפתעות',
  image: 'https://cdn.magicpatterns.com/uploads/jv9JCKZ7rbuxPY1UBjZSNt/IMG-20251007-WA0003.jpg'
}, {
  icon: Music,
  title: 'מוזיקה ואווירת חוף',
  description: 'וחה מסיבת שקיעה, בירה קרה ואנשים טובים.',
  image: 'https://cdn.magicpatterns.com/uploads/ogPVnt7wGEJk1JMJE6qQr3/IMG-20250919-WA0024.jpg'
}, {
  icon: Users,
  title: 'מפגש קהילתי',
  description: 'כל קהילת המים של ישראל במקום אחד - הזדמנות להכיר ולהתחבר',
  image: 'https://cdn.magicpatterns.com/uploads/jthr15SsJsNm2nReM2yG6L/IMG-20250201-WA0077.jpg'
}, {
  icon: Sparkles,
  title: 'התנסות בציוד חדשני',
  description: 'הזדמנות לנסות את הציוד המתקדם ביותר עם המותגים המובילים בארץ ובעולם',
  image: 'https://cdn.magicpatterns.com/uploads/7Nsyyb3XcL22vTisSrbp26/file_00000000c840720c8d220c7d5f9e2f7f_(1).png'
}];
const audience = ['חותרות וחותרים, אוהבי ספורט וספורט ימי בכל הרמות', 'חותרים מקצועיים שרוצים להתחרות ולהשתפר', 'מתחילים שרוצים לנסות לראשונה ולהתאהב בים', 'חובבי תנועה, בריאות ולייף-סטייל', 'חובבי ים שרוצים חוויה של חופש', 'כל מי שמחפש חוויה ייחודית, מהנה וקהילתית במים וביבשה'];
const reasons = [{
  title: 'האירוע היחיד מסוגו',
  description: 'שילוב נדיר של מקצועיות, חוויה וקהילה ביום אחד מרוכז'
}, {
  title: 'ציוד בלעדי',
  description: 'הזדמנות לנסות כלים וציוד שלא נגישים ביום-יום'
}, {
  title: 'האנשים הנכונים',
  description: 'לפגוש את המדריכים והחותרים שהופכים את עולם המים למה שהוא'
}, {
  title: 'לוקיישן מושלם',
  description: 'חוף מעגן עדן - רצועת החוף היפה והאקסקלוסיבית ביותר בכנרת'
}];
export function WaterTribeFestPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [showPrePaymentForm, setShowPrePaymentForm] = useState(false);
  const [selectedTicketName, setSelectedTicketName] = useState('');
  const [showIframe, setShowIframe] = useState(false);
  const [includeCompanion, setIncludeCompanion] = useState(false);
  const [showShimmer, setShowShimmer] = useState(false);
  const [pendingTicket, setPendingTicket] = useState<{
    price: number;
    name: string;
    priceDisplay: string;
    ticketType?: 'festival-only' | 'accommodation' | 'double-alone';
  } | null>(null);
  // ============================================
  // TEST MODE - DELETE THIS SECTION TO REMOVE
  // ============================================
  const [isTestMode, setIsTestMode] = useState(false);
  // ============================================
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    ;
    (window as any).openWaterTribeFestRegistrationForm = () => setIsFormOpen(true);
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    // Check for test mode URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const testModeParam = urlParams.get('test_mode');
    if (testModeParam === 'watertribe2026') {
      setIsTestMode(true);
      localStorage.setItem('test_mode_active', 'true');
      console.log('🧪 TEST MODE ACTIVATED - All prices set to ₪1');
    } else {
      // Check localStorage in case we navigated away and back
      const storedTestMode = localStorage.getItem('test_mode_active');
      if (storedTestMode === 'true') {
        setIsTestMode(true);
        console.log('🧪 TEST MODE ACTIVE (from localStorage)');
      }
    }
    // ============================================
    // Trigger shimmer animation after 0.5 seconds
    const shimmerTimer = setTimeout(() => {
      setShowShimmer(true);
      // Remove shimmer after 1.5 seconds
      setTimeout(() => setShowShimmer(false), 1500);
    }, 500);
    document.title = 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'פסטיבל החתירה השנתי בכנרת. סאפ, קיאקים, יוגה, סדנאות, הופעות וקהילה.');
    const ogTags = [{
      property: 'og:title',
      content: 'Water Tribe Fest 2026 - פסטיבל החתירה של ישראל'
    }, {
      property: 'og:description',
      content: '19-21 בנובמבר 2026 | חוף מעגן עדן, כנרת.'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/81TuRkRozsSneXuE9PPvfp/IMG-20250201-WA0062.jpg'
    }, {
      property: 'og:url',
      content: window.location.href
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  const handleCompanionOnlyPurchase = () => {
    // Direct purchase of companion ticket only - set ticket type to festival-only
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    const finalPrice = isTestMode ? 1 : 275;
    const finalPriceDisplay = isTestMode ? '1' : '275';
    // ============================================
    const companionTicket = {
      price: finalPrice,
      name: 'כרטיס מלווה בלבד',
      priceDisplay: finalPriceDisplay,
      ticketType: 'festival-only' as const
    };
    setSelectedTicketName(companionTicket.name);
    setPendingTicket(companionTicket);
    setShowPrePaymentForm(true);
    // Track Meta Pixel event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: companionTicket.name,
        content_category: 'Festival Ticket',
        value: companionTicket.price,
        currency: 'ILS'
      });
    }
  };
  const handleTicketSelect = (price: number, name: string, priceDisplay: string) => {
    // Store ticket info and open pre-payment form
    // Determine ticket type based on name
    let ticketType: 'festival-only' | 'accommodation' | 'double-alone' = 'accommodation';
    if (name.includes('פסטיבל בלבד')) {
      ticketType = 'festival-only';
    } else if (name.includes('חדר זוגי לבד') || name.includes('לילה של') && (name.includes('לזוג') || name.includes('זוגי'))) {
      // Private couple room — the room is already determined, so skip the
      // shared-room / roommate questions.
      ticketType = 'double-alone';
    }
    // ============================================
    // TEST MODE - DELETE THIS BLOCK TO REMOVE
    // ============================================
    const finalPrice = isTestMode ? 1 : price;
    const finalPriceDisplay = isTestMode ? '1' : priceDisplay;
    // ============================================
    setSelectedTicketName(name);
    setPendingTicket({
      price: finalPrice,
      name,
      priceDisplay: finalPriceDisplay,
      ticketType
    });
    setShowPrePaymentForm(true);
    // Track Meta Pixel event - Ticket Selected
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: name,
        content_category: 'Festival Ticket',
        value: finalPrice,
        currency: 'ILS'
      });
    }
  };
  const handlePrePaymentFormSubmit = async (formData: any) => {
    // Generate unique order number
    const orderNumber = generateOrderNumber();
    // CRITICAL: Capture UTM params NOW, at form submission time
    // This ensures they're stored with the registration data
    // and won't be lost if localStorage is cleared during payment
    const utmParams = getUtmParams();
    console.log('📊 Capturing UTM params at form submission:', utmParams);
    // Map form data to proper format
    const submissionData = {
      name: formData.fullName,
      phone: formData.phone,
      email: formData.email,
      orderNumber: orderNumber,
      ticketType: pendingTicket?.name || '',
      price: pendingTicket?.priceDisplay || '',
      gender: formData.gender === 'male' ? 'זכר' : formData.gender === 'female' ? 'נקבה' : '',
      companionName: formData.companionName || '',
      companionPhone: formData.companionPhone || '',
      companionGender: formData.companionGender === 'male' ? 'זכר' : formData.companionGender === 'female' ? 'נקבה' : '',
      nightChoice: formData.nightChoice === 'thursday' ? 'חמישי' : formData.nightChoice === 'friday' ? 'שישי' : '',
      roomType: formData.roomType === 'double' ? 'זוגי' : formData.roomType === 'triple' ? 'טריפל' : '',
      roommate1: formData.roommate1Name || '',
      roommate2: formData.roommate2Name || '',
      competitiveTrack: formData.competitiveTrack && formData.competitiveTrack.length > 0 ? formData.competitiveTrack.map((t: string) => {
        if (t === 'no') return 'לא';
        if (t === 'sprint') return 'ספרינט';
        if (t === 'technical') return 'טכני';
        if (t === 'longDistance') return 'לונג דיסטנס';
        return t;
      }).join(', ') : 'לא',
      rowingType: formData.rowingType === 'sup' ? 'סאפ' : formData.rowingType === 'race' ? 'רייס' : formData.rowingType === 'surfski' ? 'סרפסקי' : formData.rowingType === 'surfer' ? 'גולש' : formData.rowingType === 'atmosphere' ? 'סופג אווירה' : '',
      clubName: formData.belongsToClub === 'yes' && formData.clubName ? formData.clubName : 'לא שייך למועדון',
      rentBoard: formData.rentBoard === 'yes' ? 'כן' : formData.rentBoard === 'no' ? 'לא' : '',
      whatsappGroup: formData.whatsappGroup ? 'כן' : 'לא',
      type: 'הרשמה Water Tribe Fest',
      source: 'טופס תשלום',
      // CRITICAL: Include UTM params directly in registration data
      // This ensures they survive localStorage clearing in Meta in-app browsers
      utm_source: utmParams.utm_source,
      utm_medium: utmParams.utm_medium,
      utm_campaign: utmParams.utm_campaign,
      utm_content: utmParams.utm_content,
      utm_term: utmParams.utm_term,
      utm_id: utmParams.utm_id,
      fbclid: utmParams.fbclid
    };
    // Store order details in localStorage for thank you page
    localStorage.setItem('pendingOrder', JSON.stringify({
      orderNumber: orderNumber,
      name: formData.fullName,
      email: formData.email,
      timestamp: Date.now()
    }));
    // Store registration data for Make.com webhook (sent after payment success)
    localStorage.setItem('pendingRegistrationData', JSON.stringify(submissionData));
    console.log('📦 Registration data stored, waiting for payment...');
    // Close the form
    setShowPrePaymentForm(false);
    // Track Meta Pixel event - Initiate Checkout
    if (window.fbq && pendingTicket) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: pendingTicket.name,
        content_category: 'Festival Ticket',
        value: pendingTicket.price,
        currency: 'ILS',
        num_items: 1
      });
    }
    // Show iframe container
    setShowIframe(true);
    // Open Tranzila payment using the utility function
    if (pendingTicket) {
      // Small delay to ensure iframe is rendered
      setTimeout(() => {
        openTranzilaPayment({
          sum: pendingTicket.price,
          contact: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          pdesc: `Water Tribe Fest 2026 - ${pendingTicket.name}`,
          success_url: `${window.location.origin}/tranzila-success`,
          fail_url: `${window.location.origin}/water-tribe-fest`,
          u1: orderNumber,
          u2: pendingTicket.name,
          u3: pendingTicket.priceDisplay
        });
        // Scroll to iframe after submission
        setTimeout(() => {
          iframeRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }, 100);
    }
  };
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1966" data-mp="3i9urveg3qlql">
      <UtmCapture data-id="element-1967" data-mp="3n6bbbvccwbxc" />
      <Navigation data-id="element-1968" data-mp="3n6tj9p8dsel3" />

      {/* ============================================ */}
      {/* TEST MODE INDICATOR - DELETE THIS TO REMOVE */}
      {/* ============================================ */}
      {isTestMode && <div className="fixed top-4 left-4 z-50 bg-yellow-500 text-black px-4 py-2 rounded-lg shadow-lg font-bold text-sm flex items-center gap-2" data-id="element-1969" data-mp="kgds9wdp4a">
          <Zap className="w-4 h-4" data-id="element-1970" data-mp="21utfpvoi83k1" />
          TEST MODE - ₪1
        </div>}
      {/* ============================================ */}

      {/* Hero */}
      <div className="relative h-screen min-h-[600px] overflow-hidden flex items-center justify-center" data-id="element-1971" data-mp="1z9bzt0wajz1a">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/40 via-blue-800/20 to-[#0A5F8F]/90 z-10" data-id="element-1972" data-mp="1uivj97x6bxap" />
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-1973" data-mp="1pir2dgsct0jy">
          <source src="https://cdn.magicpatterns.com/uploads/bHRRxzcgoWuLZVsSMLwyGt/VID-20251224-WA0026.undefined" type="video/mp4" data-id="element-1974" data-mp="1kil5nm788nv0" />
        </video>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-20" data-id="element-1975" data-mp="2d70iq36ssw3p" />

        <div className="relative z-30 container mx-auto px-4 text-center text-white" data-id="element-1976" data-mp="28buz5b0vbtis">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1977" data-mp="24ahpsqykh874">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full mb-6 border border-white/30" data-id="element-1978" data-mp="ubqcs8v6s4oc">
              <Calendar className="w-5 h-5" data-id="element-1979" data-mp="kc9cy82m8l0a" />
              <span className="font-medium" data-id="element-1980" data-mp="kb7rd9nz4g4b">19-21 בנובמבר 2026</span>
              <span className="mx-2" data-id="element-1981" data-mp="pb2i9d7r15pd">|</span>
              <MapPin className="w-5 h-5" data-id="element-1982" data-mp="p9rcj7uqtnvm" />
              <span data-id="element-1983" data-mp="bk7egfc3xesn">חוף מעגן עדן, כנרת</span>
            </div>

            <h1 className="text-6xl md:text-8xl font-black mb-4 tracking-tight drop-shadow-lg" data-id="element-1984" data-mp="biml2t1j41wd">
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-white" data-id="element-1985" data-mp="gbyu3utq6040">
                WATER TRIBE
              </span>
              <span className="block mt-2" data-id="element-1986" data-mp="6k1iimyt164r">FEST 2026</span>
            </h1>

            <p className="text-2xl md:text-4xl font-light mb-12 text-blue-100 max-w-3xl mx-auto" data-id="element-1987" data-mp="3oqfxmp8t7m4q">
              פסטיבל החתירה השנתי של ישראל
            </p>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.5
          }} className="text-center" data-id="element-1988" data-mp="3srjbx7b7la3u">
              <div className="text-white text-xl md:text-2xl font-light mb-3" data-id="element-1989" data-mp="3j58d22g8b4lg">
                לכל הפרטים המשיכו לגלול
              </div>
              <motion.div animate={{
              y: [0, 12, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="text-white text-4xl" data-id="element-1990" data-mp="3e7otqo4oc1mn">
                ↓
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Story */}
      <section className="py-12 bg-white" data-id="element-1991" data-mp="foi0t5u1zvbb">
        <div className="container mx-auto px-4" data-id="element-1992" data-mp="aon9j16d93pq">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1993" data-mp="apyayucc9zdo">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-6xl font-bold text-[#0A5F8F] mb-8" data-id="element-1994" data-mp="1i1cmsz9t9khg">
              זה לא עוד אירוע ספורט
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-1995" data-mp="ye4zgbyox4r8">
              זה סופשבוע אחד שמאחד את כל תרבות החתירה בישראל:
              <br data-id="element-1996" data-mp="kkdvrk7n4f3f" />
              <span className="font-bold text-gray-900" data-id="element-1997" data-mp="kjubhwuipem8">
                מים, קהילה, חוויה וגופנפש.
              </span>
            </motion.p>
          </div>
        </div>
      </section>

      {/* Activities */}
      <section className="py-16 bg-gray-50" data-id="element-1998" data-mp="818irsucmqzc">
        <div className="container mx-auto px-4" data-id="element-1999" data-mp="336xr2dd4hl8">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-2000" data-mp="362voqp7n69o">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2001" data-mp="3lgenavraffkk">
              מה מחכה לכם בפסטיבל?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-2002" data-mp="3ggjswi8b07ur">
              הפסטיבל שמאגד את כל מה שאתם אוהבים בים - בסופשבוע אחד
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2003" data-mp="36jf7wlq72ifj">
            {activities.map((activity, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`rounded-3xl shadow-lg hover:shadow-xl transition-all border border-gray-100 overflow-hidden h-full min-h-[300px] relative ${index === activities.length - 1 ? 'col-span-2 md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-2004" data-mp="32lhfzb51hi8g" data-mpi={index}>
                <div className="absolute inset-0" data-id="element-2005" data-mp="yon9ds4uip79">
                  <img src={activity.image} alt={activity.title} className={`w-full h-full object-cover ${activity.imagePosition || 'object-center'}`} data-id="element-2006" data-mp="uqfqaqmwtbsw" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" data-id="element-2007" data-mp="ks09phlidkxn" />
                </div>
                <div className="relative z-10 p-8 h-full flex flex-col justify-end" data-id="element-2008" data-mp="31desgcegrbuh">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-2009" data-mp="31fhp3fa4g386">
                    {activity.title}
                  </h3>
                  <p className="text-gray-200 text-sm leading-relaxed" data-id="element-2010" data-mp="3aev0idht31vj">
                    {activity.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Who Should Come */}
      <section className="py-24 bg-[#0A5F8F] text-white relative overflow-hidden" data-id="element-2011" data-mp="2moseof4his5d">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-2012" data-mp="2mmo115gsaerw" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-2013" data-mp="1uxulzb24b7jw" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-2014" data-mp="1yy4twt9h081e">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-2015" data-mp="329u0e24yy5mw">
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-2016" data-mp="327r2kvxkr87m">
              <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-2017" data-mp="3736e3h840s0v">
                למי הפסטיבל
                <br data-id="element-2018" data-mp="2ec4un3xdwabj" />
                <span className="text-cyan-300" data-id="element-2019" data-mp="2ecoewraibasq">מתאים?</span>
              </h2>
              <p className="text-xl text-blue-100 mb-8 max-w-md" data-id="element-2020" data-mp="2sbxov984d8o9">
                בין אם אתם חותרים מקצועיים או שמעולם לא עליתם על סאפ - הפסטיבל
                הזה הוא בשבילכם.
              </p>
            </motion.div>

            <div className="space-y-4" data-id="element-2021" data-mp="7kxax9ox13as">
              {audience.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/10" data-id="element-2022" data-mp="3kmu11zl4sh5" data-mpi={index}>
                  <div className="bg-cyan-400 rounded-full p-1 shrink-0" data-id="element-2023" data-mp="ysxdso0hice4">
                    <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-2024" data-mp="yv1gx3qk77dc" />
                  </div>
                  <span className="text-lg font-medium" data-id="element-2025" data-mp="k2809ezjwl73">{item}</span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Why Miss (FOMO) */}
      <section className="py-24 bg-gradient-to-br from-orange-50 to-rose-50" data-id="element-2026" data-mp="1cr578lybavkj">
        <div className="container mx-auto px-4" data-id="element-2027" data-mp="1hkzqxpdx3ajm">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-2028" data-mp="3q1ak1apezr4s">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-1 rounded-full font-bold mb-4" data-id="element-2029" data-mp="3b4jtlqxpxprb">
              <Flame className="w-5 h-5" data-id="element-2030" data-mp="cl33o13myc0s" />
              <span data-id="element-2031" data-mp="7n1ohr9bywul">FOMO ALERT</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6" data-id="element-2032" data-mp="7njqz5ml67ay">
              למה אסור לפספס?
            </h2>
          </motion.div>

          <div className="max-w-5xl mx-auto" data-id="element-2033" data-mp="3u2w2rcomqzmw">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-orange-100" data-id="element-2034" data-mp="3u22sw2udju0j">
              <ul className="space-y-4" data-id="element-2035" data-mp="12wdjpiv5r59t">
                {reasons.map((reason, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-4" data-id="element-2036" data-mp="17u6me1x95h5c" data-mpi={index}>
                    <div className="bg-orange-100 rounded-full p-1 shrink-0 mt-1" data-id="element-2037" data-mp="20k5jmkllokl3">
                      <CheckCircle2 className="w-5 h-5 text-orange-600" data-id="element-2038" data-mp="25iqc1xum1zyz" />
                    </div>
                    <div data-id="element-2039" data-mp="1fukwj0ch2jl7">
                      <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-2040" data-mp="1ftrxkljr8ydm">
                        {reason.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-2041" data-mp="1axb4dcxp7tto">{reason.description}</p>
                    </div>
                  </motion.li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Accommodation */}
      <section className="py-24 bg-gradient-to-br from-blue-50 to-cyan-50" data-id="element-2042" data-mp="1yk176ghvfsfc">
        <div className="container mx-auto px-4" data-id="element-2043" data-mp="1tm7zfj0x6qcy">
          <div className="max-w-5xl mx-auto" data-id="element-2044" data-mp="1tlpxq6vhnjxn">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-2045" data-mp="28iyvpjfarlyc">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-2046" data-mp="97pa0knnm6qo">
                <Calendar className="w-5 h-5" data-id="element-2047" data-mp="2kvu4w48vbu1s" />
                <span data-id="element-2048" data-mp="2prj8cio0dv3d">לוח זמנים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2049" data-mp="2pudvwj2bjw10">
                מה לו"ז האירוע?
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-2050" data-mp="2g1zphd0aq18i">
                שלושה ימים מלאים בפעילויות, חוויות וקהילה
              </p>
            </motion.div>

            <div className="space-y-8 mb-16" data-id="element-2051" data-mp="225crd6wlx510">
              {/* Thursday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 shadow-lg border border-blue-100" data-id="element-2052" data-mp="265wo49d9q6mm">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-2053" data-mp="2eatqxw785me3">
                  <Calendar className="w-8 h-8" data-id="element-2054" data-mp="2a9qd1f8qm0fi" />
                  יום חמישי, 19.11.2026
                </h3>
                <div className="space-y-4" data-id="element-2055" data-mp="25i89qkj8rnrd">
                  {[{
                  time: '14:00 - 15:00',
                  activity: 'הגעה, קבלת חדרים והרשמה'
                }, {
                  time: '15:00 - 16:00',
                  activity: 'מקצה ספרינטים'
                }, {
                  time: '16:30 - 18:00',
                  activity: 'חתירת שקיעה'
                }, {
                  time: '20:00 - 21:00',
                  activity: 'הרצאת השראה'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-2056" data-mp="3gvkgb36dykh8" data-mpi={index}>
                      <div className="bg-blue-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-2057" data-mp="3jg8sl5uxsfm2">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-2058" data-mp="3t8xyzmbmr3aj">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Friday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-3xl p-8 shadow-lg border border-cyan-100" data-id="element-2059" data-mp="35jmz0723tcxg">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-2060" data-mp="1kvm2dozvz7x0">
                  <Calendar className="w-8 h-8" data-id="element-2061" data-mp="1pt5h0q0hxmph" />
                  יום שישי, 20.11.2026
                </h3>
                <div className="space-y-4" data-id="element-2062" data-mp="1b2y8b20aji1z">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'יוגהלאטיס על סאפ'
                }, {
                  time: '8:00 - 9:00',
                  activity: 'מקצה טכני תחרותי'
                }, {
                  time: '9:00 - 11:00',
                  activity: 'יציאה לשני מסלולי חתירה חוויתיים לבחירה: מסלול מעגלי בדרום הכנרת - כ-10 ק"מ, ירדנית - 3 ק"מ'
                }, {
                  time: '11:00',
                  activity: 'פתיחת מתחם אקספו - הדגמות, התנסויות, מוסיקה ופינוקים'
                }, {
                  time: '11:30 - 13:30',
                  activity: 'סדנת חתירה למתחילים | סדנת טכניקה למתקדמים | סדנת אקרויוגה'
                }, {
                  time: '14:00 - 16:00',
                  activity: 'סדנת תיקונים עם זזיק | מבוא לגלישת ווינג'
                }, {
                  time: '17:00 - 19:00',
                  activity: 'מסיבת חוף עם DJ'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-2063" data-mp="18l4kr31sdtwd" data-mpi={index}>
                      <div className="bg-cyan-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-2064" data-mp="3aby6k82db7ct">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-2065" data-mp="199q7d07w86r4">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>

              {/* Saturday */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-3xl p-8 shadow-lg border border-teal-100" data-id="element-2066" data-mp="1i93jy1rbdbg2">
                <h3 className="text-3xl font-bold text-[#0A5F8F] mb-6 flex items-center gap-3" data-id="element-2067" data-mp="2az3rk8d792mm">
                  <Calendar className="w-8 h-8" data-id="element-2068" data-mp="2fy6kwvjthker" />
                  יום שבת, 21.11.2026
                </h3>
                <div className="space-y-4" data-id="element-2069" data-mp="2q23pgr25jbdi">
                  {[{
                  time: '7:00 - 7:45',
                  activity: 'מתיחות ותרגילי כוח על סאפ'
                }, {
                  time: '7:15',
                  activity: 'מסלול תחרותי Long Distance - 10 ק"מ'
                }, {
                  time: '9:00 - 10:30',
                  activity: 'יציאה למסלול חווייתי'
                }, {
                  time: '11:00',
                  activity: 'מקצה מועדונים - מירוץ שליחים'
                }, {
                  time: '12:30',
                  activity: 'פודיום, נשיקות וחיבוקים'
                }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-4 rounded-xl flex-row-reverse" data-id="element-2070" data-mp="3rjw5l2ti41m0" data-mpi={index}>
                      <div className="bg-teal-600 text-white px-4 py-2 rounded-lg font-bold text-sm whitespace-nowrap shrink-0" data-id="element-2071" data-mp="37a3bfi6m109h">
                        {item.time}
                      </div>
                      <div className="text-gray-800 font-medium pt-2 text-right" data-id="element-2072" data-mp="2yagcd31cs6jl">
                        {item.activity}
                      </div>
                    </div>)}
                </div>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-12" data-id="element-2073" data-mp="3q36z8mx5ciw6">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-2074" data-mp="cu2hqnkopkv4">
                <MapPin className="w-5 h-5" data-id="element-2075" data-mp="hmlwvoz0so21" />
                <span data-id="element-2076" data-mp="22b6hihgrji17">אירוח במקום</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2077" data-mp="229n20t2xlb0h">
                שלושה ימים מלאים? הישארו לישון!
              </h2>
              <p className="text-xl text-gray-600" data-id="element-2078" data-mp="2c1srnw5pngci">
                כפר הנופש מעגן מציע אירוח נוח במחירים מיוחדים למשתתפי הפסטיבל
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-blue-100" data-id="element-2079" data-mp="274iv7wjwm4f6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-2080" data-mp="1odrlgtw08c09">
                <div data-id="element-2081" data-mp="34o3rv5penf8s">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2082" data-mp="34rri9vzjzlja">
                    למה לישון במקום?
                  </h3>
                  <ul className="space-y-4" data-id="element-2083" data-mp="36utmj1da1j4l">
                    {['תתחילו את הבוקר ישר על החוף', 'לא תפספסו אף רגע מהפסטיבל', 'תיהנו ממסיבת הערב עד הסוף', 'מחירים מיוחדים למשתתפי הפסטיבל', 'חדרים נוחים וממוזגים'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-2084" data-mp="2o3kdsubbyye2" data-mpi={index}>
                        <div className="bg-blue-100 rounded-full p-1" data-id="element-2085" data-mp="2o1fylg7zecyh">
                          <CheckCircle2 className="w-5 h-5 text-[#0A5F8F]" data-id="element-2086" data-mp="2t3f34tfgjfx0" />
                        </div>
                        <span className="text-gray-700" data-id="element-2087" data-mp="2y05ifejfu7hd">{item}</span>
                      </li>)}
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-2xl p-8 text-white text-center" data-id="element-2088" data-mp="25dks8hep81fe">
                  <MapPin className="w-12 h-12 mx-auto mb-4" data-id="element-2089" data-mp="2ab44xcvr0658" />
                  <h4 className="text-2xl font-bold mb-2" data-id="element-2090" data-mp="rh1careu8ve2">כפר הנופש מעגן</h4>
                  <p className="text-blue-100 mb-6" data-id="element-2091" data-mp="rex5a0ln7g9k">
                    אירוח איכותי במחירים נוחים
                  </p>
                  <div className="space-y-3" data-id="element-2092" data-mp="ig337upjlxom">
                    <a href="https://www.maagan.co.il/category/%d7%94%d7%97%d7%93%d7%a8%d7%99%d7%9d/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-2093" data-mp="if1uhww01na2">
                      <span className="font-medium" data-id="element-2094" data-mp="3vwatpx51ct6c">תיאור החדרים</span>
                    </a>
                    <a href="https://www.maagan.co.il/%d7%a9%d7%90%d7%9c%d7%95%d7%aa-%d7%95%d7%aa%d7%a9%d7%95%d7%91%d7%95%d7%aa/uncategorized/" target="_blank" rel="noopener noreferrer" className="block bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl transition-colors border border-white/30" data-id="element-2095" data-mp="3qwxyao03mds5">
                      <span className="font-medium" data-id="element-2096" data-mp="1dntxc5xu68qo">
                        מידע נוסף על כפר הנופש
                      </span>
                    </a>
                  </div>
                  <p className="text-sm text-blue-200 mt-4" data-id="element-2097" data-mp="14mw3ggh43hlt">
                    מספר החדרים מוגבל - הזמינו מוקדם!
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-2098" data-mp="uqjbpo54ndtp">
              <Button size="lg" className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-2099" data-mp="720317i60z13">
                להרשמה המשיכו לגלול למטה ↓
              </Button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing-section" className="py-24 bg-gradient-to-br from-indigo-50 to-purple-50" data-id="element-2100" data-mp="barer32z971u">
        <div className="container mx-auto px-4" data-id="element-2101" data-mp="78ebclbpdl88">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-6xl mx-auto" data-id="element-2102" data-mp="l25dh8n3u2tx">
            <div className="text-center mb-12" data-id="element-2103" data-mp="q29tkxk3ovjm">
              <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-600 px-4 py-2 rounded-full font-bold mb-4" data-id="element-2104" data-mp="xqit2trubrcg">
                <CreditCard className="w-5 h-5" data-id="element-2105" data-mp="ss7l6ol3vqwv" />
                <span data-id="element-2106" data-mp="spd14y60883z">רכישת כרטיסים</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-2107" data-mp="17hdq8t6mkbco">
                מחירי הפסטיבל
              </h2>
              <p className="text-xl text-gray-600 mb-8" data-id="element-2108" data-mp="12oat6b2n2jrq">
                הירשמו עכשיו והבטיחו את מקומכם!
              </p>

              {/* What's Included Section */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-3xl p-8 md:p-10 border border-cyan-100 shadow-lg mb-12" data-id="element-2109" data-mp="1cenei5ia2gyx">
                <div className="flex items-start gap-4" data-id="element-2110" data-mp="22pftmdc707tp">
                  <div className="bg-cyan-500 rounded-full p-3 shrink-0" data-id="element-2111" data-mp="22pxs7gmbuy4s">
                    <Sparkles className="w-6 h-6 text-white" data-id="element-2112" data-mp="27nh9yqi8ht1h" />
                  </div>
                  <div data-id="element-2113" data-mp="1t0ebagi6deck">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-2114" data-mp="1syuv0pwir3as">
                      מה כלול במחיר?
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-2115" data-mp="1xwcvrt0duc7p">
                      המחיר כולל השתתפות מלאה ב<strong data-id="element-2116" data-mp="1k1ar1979uswh">כ-ל</strong> חוויית
                      הפסטיבל – כל הסדנאות, הרצאות, חתירות, טבילה מרעננת
                      באמבטיית קרח, בירה קרה ועוד הפתעות 🎉
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Companion Toggle Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className={`mb-8 rounded-3xl p-6 md:p-8 transition-all shadow-xl ${includeCompanion ? 'bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500' : 'bg-white border-2 border-gray-200'}`} data-id="element-2117" data-mp="34ejj5klie8d6">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-2118" data-mp="2txpkj9p8xe03">
                <div className={`rounded-2xl p-4 shrink-0 transition-all ${includeCompanion ? 'bg-white/20 backdrop-blur-sm' : 'bg-gradient-to-br from-emerald-50 to-teal-50'}`} data-id="element-2119" data-mp="3qmx9ysszk79a">
                  <Users className={`w-8 h-8 ${includeCompanion ? 'text-white' : 'text-emerald-600'}`} data-id="element-2120" data-mp="3gwluqa3uqbn3" />
                </div>

                <div className="flex-1" data-id="element-2121" data-mp="3ctz7kmi4lew8">
                  <h3 className={`text-2xl md:text-3xl font-black mb-2 leading-tight ${includeCompanion ? 'text-white' : 'text-gray-900'}`} data-id="element-2122" data-mp="d9c33odnrhq5">
                    באים עם מישהו שלא חותר?
                  </h3>
                  <p className={`text-base md:text-lg mb-5 leading-relaxed font-semibold ${includeCompanion ? 'text-white/90' : 'text-gray-700'}`} data-id="element-2123" data-mp="1r6enpte5rfnk">
                    הוסיפו כרטיס מלווה ותהנו יחד מהאווירה, המסיבות והפינוקים 🎉
                  </p>

                  {/* What's Included - Always show */}
                  <div className={`rounded-2xl p-4 mb-5 border transition-all ${includeCompanion ? 'bg-white/10 backdrop-blur-md border-white/20' : 'bg-gradient-to-br from-emerald-50 to-teal-50 border-emerald-200'}`} data-id="element-2124" data-mp="2a3zex74eaqbc">
                    <div className="mb-3" data-id="element-2125" data-mp="2jvdc388vje1b">
                      <div className="flex items-center gap-2 mb-1" data-id="element-2126" data-mp="2nuukoajlkrap">
                        <Sparkles className={`w-5 h-5 ${includeCompanion ? 'text-white' : 'text-emerald-600'}`} data-id="element-2127" data-mp="2stxnrpg0ong1" />
                        <span className={`font-bold ${includeCompanion ? 'text-white' : 'text-emerald-900'}`} data-id="element-2128" data-mp="2xt1um9fgy937">
                          כלול בכרטיס מלווה:
                        </span>
                      </div>
                      <p className={`text-sm font-semibold pr-7 ${includeCompanion ? 'text-white/90' : 'text-emerald-700'}`} data-id="element-2129" data-mp="2tutf9secu6va">
                        כל חוויות הפסטיבל!
                      </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5" data-id="element-2130" data-mp="1w84a59ocve57">
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2131" data-mp="1wa7424smprf7">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2132" data-mp="264z3le5ruocm" />
                        <span data-id="element-2133" data-mp="3mjh603hvhog8">מסיבות ואווירה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2134" data-mp="3hlyuq6gdux52">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2135" data-mp="3u41irvfwwsvv" />
                        <span data-id="element-2136" data-mp="3u5cm5u5g3ymg">סדנאות חוויה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2137" data-mp="3g5bjqa9j8j4v">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2138" data-mp="bps9zaati23q" />
                        <span data-id="element-2139" data-mp="gp584r752vlm">הרצאות השראה</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2140" data-mp="godevn10l9yi">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2141" data-mp="6xsg9zlcc5fl" />
                        <span data-id="element-2142" data-mp="uoo3skirkeh1">מגוון פינוקים</span>
                      </div>
                      <div className={`flex items-center gap-2 text-sm ${includeCompanion ? 'text-white/90' : 'text-emerald-800'}`} data-id="element-2143" data-mp="zfmp5yim02r5">
                        <CheckCircle2 className="w-4 h-4 shrink-0" data-id="element-2144" data-mp="199ado3frz0j8" />
                        <span data-id="element-2145" data-mp="15ajdfng0j2rw">וגם...</span>
                      </div>
                    </div>
                    <div className={`mt-3 pt-3 border-t ${includeCompanion ? 'border-white/20' : 'border-emerald-200'}`} data-id="element-2146" data-mp="109n8d6jxdakw">
                      <div className={`flex items-center gap-2 text-xs ${includeCompanion ? 'text-white/70' : 'text-red-500'}`} data-id="element-2147" data-mp="qdaiykvexivy">
                        <X className="w-3.5 h-3.5 shrink-0" data-id="element-2148" data-mp="hkgnpdzkm8wg" />
                        <span data-id="element-2149" data-mp="hkyrqwsh5rex">ללא סדנאות מקצועיות ומקצי חתירה</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-center gap-4" data-id="element-2150" data-mp="7m9ifsen9faa">
                    <motion.button whileHover={{
                    scale: 1.02
                  }} whileTap={{
                    scale: 0.98
                  }} onClick={() => setIncludeCompanion(!includeCompanion)} className={`relative overflow-hidden w-full max-w-[280px] px-8 py-4 rounded-2xl font-bold text-lg transition-all shadow-lg ${includeCompanion ? 'bg-white text-emerald-600 shadow-white/30' : 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-emerald-500/40'}`} data-id="element-2151" data-mp="7odnidoa4kc5">
                      {showShimmer && !includeCompanion && <motion.div initial={{
                      x: '-100%'
                    }} animate={{
                      x: '200%'
                    }} transition={{
                      duration: 1.5,
                      ease: 'easeInOut'
                    }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-2152" data-mp="3axqwuw50rqa2" />}
                      <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-2153" data-mp="679tgpiah8dm">
                        <Users className="w-5 h-5" data-id="element-2154" data-mp="k711m9m4jujp" />
                        {includeCompanion ? <>
                            <CheckCircle2 className="w-5 h-5" data-id="element-2155" data-mp="f5lemc0dzdyo" />
                            מלווה נוסף
                          </> : 'הוסף מלווה'}
                      </span>
                    </motion.button>

                    <button onClick={handleCompanionOnlyPurchase} className={`font-medium text-sm md:text-base transition-colors ${includeCompanion ? 'text-white/80 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-2156" data-mp="12vzayeq07yz2">
                      רוצים כרטיס מלווה בלבד ב-₪275?
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Premium Rooms Info */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#0A5F8F]/5 to-cyan-50 rounded-3xl p-6 md:p-8 mb-8 shadow-lg border border-cyan-200" data-id="element-2157" data-mp="1vifhfxccus9y">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-2158" data-mp="1clxvjwk6tmlm">
                <div className="bg-gradient-to-br from-[#0A5F8F] to-cyan-600 rounded-2xl p-4 shrink-0" data-id="element-2159" data-mp="yuj89dj8yz8r">
                  <Sparkles className="w-8 h-8 text-white" data-id="element-2160" data-mp="13potsb8qmbwb" />
                </div>
                <div className="flex-1" data-id="element-2161" data-mp="ov26v8b137il">
                  <h3 className="text-2xl md:text-3xl font-black text-[#0A5F8F] mb-3" data-id="element-2162" data-mp="ttlqv362a98b">
                    ✨ חדרי פרמיום — לחוויה המושלמת
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed mb-5" data-id="element-2163" data-mp="pqr0us0rvbla">
                    חדרי הפרמיום ממוקמים{' '}
                    <strong data-id="element-2164" data-mp="uq3vhyxvxmyf">בשורות הראשונות לקו הים</strong> — להתעורר עם נוף
                    ישיר לכנרת!
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-2165" data-mp="13pgwe37y137j">
                    {['מבנה אבן מעוצב וצמוד קרקע', 'אבזור עשיר ומפנק', 'מרפסת עם נוף לכנרת', 'מיזוג אוויר ומקלחת מפנקת'].map((feature, index) => <div key={index} className="flex items-center gap-2.5" data-id="element-2166" data-mp="1iedcmnk5lmj8" data-mpi={index}>
                        <div className="bg-cyan-100 rounded-full p-0.5" data-id="element-2167" data-mp="1nbwppk547t9l">
                          <CheckCircle2 className="w-4 h-4 text-[#0A5F8F]" data-id="element-2168" data-mp="1retextp5unmi" />
                        </div>
                        <span className="text-gray-800 font-medium text-sm" data-id="element-2169" data-mp="1wd38y0z5fi6j">
                          {feature}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-2170" data-mp="37uz6et3rpr47">
              {[{
              name: 'חדר פרמיום לזוג - כל הסופ״ש (לאדם)',
              priceDisplay: '1,990',
              price: 1990,
              priceWithCompanionDisplay: '3,730',
              priceWithCompanion: 3730,
              showWithCompanion: true,
              companionParticipant: '1,990',
              companionAddon: '1,740'
            }, {
              name: 'חדר פרמיום ל-3 אנשים - כל הסופ״ש (לאדם)',
              priceDisplay: '1,490',
              price: 1490,
              priceWithCompanionDisplay: '2,730',
              priceWithCompanion: 2730,
              showWithCompanion: true,
              companionParticipant: '1,490',
              companionAddon: '1,240'
            }, {
              name: 'חדר פרמיום ל-3 אנשים - לילה של חמישי (לאדם)',
              priceDisplay: '920',
              price: 920,
              priceWithCompanionDisplay: '920',
              priceWithCompanion: 920,
              showWithCompanion: false,
              companionParticipant: '920',
              companionAddon: '0'
            }, {
              name: 'חדר פרמיום ל-3 אנשים - לילה של שישי (לאדם)',
              priceDisplay: '980',
              price: 980,
              priceWithCompanionDisplay: '980',
              priceWithCompanion: 980,
              showWithCompanion: false,
              companionParticipant: '980',
              companionAddon: '0'
            }, {
              name: 'חדר פרמיום לזוג - לילה של חמישי (לאדם)',
              priceDisplay: '1,150',
              price: 1150,
              priceWithCompanionDisplay: '1,150',
              priceWithCompanion: 1150,
              showWithCompanion: false,
              companionParticipant: '1,150',
              companionAddon: '0'
            }, {
              name: 'חדר פרמיום לזוג - לילה של שישי (לאדם)',
              priceDisplay: '1,280',
              price: 1280,
              priceWithCompanionDisplay: '1,280',
              priceWithCompanion: 1280,
              showWithCompanion: false,
              companionParticipant: '1,280',
              companionAddon: '0'
            }, {
              name: 'חדר קלאסי זוגי - כל הסופ״ש (לאדם)',
              priceDisplay: '1,650',
              price: 1650,
              priceWithCompanionDisplay: '1,650',
              priceWithCompanion: 1650,
              showWithCompanion: false,
              companionParticipant: '1,650',
              companionAddon: '0'
            }, {
              name: 'חדר קלאסי זוגי - לילה של חמישי (לאדם)',
              priceDisplay: '1,090',
              price: 1090,
              priceWithCompanionDisplay: '1,090',
              priceWithCompanion: 1090,
              showWithCompanion: false,
              companionParticipant: '1,090',
              companionAddon: '0'
            }, {
              name: 'חדר קלאסי זוגי - לילה של שישי (לאדם)',
              priceDisplay: '1,190',
              price: 1190,
              priceWithCompanionDisplay: '1,190',
              priceWithCompanion: 1190,
              showWithCompanion: false,
              companionParticipant: '1,190',
              companionAddon: '0'
            }, {
              name: 'הרשמה לפסטיבל בלבד',
              priceDisplay: '485',
              price: 485,
              priceWithCompanionDisplay: '760',
              priceWithCompanion: 760,
              showWithCompanion: true,
              companionParticipant: '485',
              companionAddon: '275'
            }].filter(item => !includeCompanion || item.showWithCompanion).map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} whileHover={{
              scale: 1.03,
              y: -5
            }} className={`bg-white rounded-3xl p-6 shadow-lg border transition-all cursor-pointer flex flex-col justify-between h-full relative overflow-hidden group ${selectedTicketName === item.name ? includeCompanion ? 'border-green-500 ring-2 ring-green-500 shadow-xl' : 'border-indigo-500 ring-2 ring-indigo-500 shadow-xl' : includeCompanion ? 'border-green-100 hover:shadow-xl hover:border-green-300' : 'border-indigo-100 hover:shadow-xl hover:border-indigo-300'}`} onClick={() => handleTicketSelect(includeCompanion ? item.priceWithCompanion || item.price : item.price, includeCompanion && item.showWithCompanion ? `${item.name} + כרטיס מלווה` : item.name, includeCompanion ? item.priceWithCompanionDisplay || item.priceDisplay : item.priceDisplay)} data-id="element-2171" data-mp="lln2re8apz7a" data-mpi={index}>
                    <div className={`absolute top-0 right-0 w-24 h-24 rounded-bl-full -mr-4 -mt-4 opacity-50 group-hover:scale-110 transition-transform ${includeCompanion ? 'bg-gradient-to-br from-green-100 to-transparent' : 'bg-gradient-to-br from-indigo-100 to-transparent'}`} data-id="element-2172" data-mp="zsbg4heb29qm" />

                    <div className="relative z-10" data-id="element-2173" data-mp="2l5e7ub44e93w">
                      <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight min-h-[3.5rem]" data-id="element-2174" data-mp="2l433oa6rizc9">
                        {item.name}
                      </h3>

                      {includeCompanion && item.showWithCompanion && <div className="mb-3" data-id="element-2175" data-mp="efaz5lbmp18h">
                          <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-bold" data-id="element-2176" data-mp="ijqzz86dxigu">
                            <Users className="w-4 h-4" data-id="element-2177" data-mp="nfz9a4xwihg3" />+ כרטיס מלווה
                          </span>

                          {/* Price Breakdown */}
                          <div className="mt-3 p-3 bg-green-50 rounded-lg border border-green-100" data-id="element-2178" data-mp="x6k9fwt83u14">
                            <div className="text-xs text-gray-600 space-y-1" data-id="element-2179" data-mp="125dldksv3cz6">
                              <div className="flex justify-between items-center" data-id="element-2180" data-mp="1681vrwx84ry9">
                                <span data-id="element-2181" data-mp="1b74ochw0p5pc">משתתף:</span>
                                <span className="font-semibold text-gray-900" data-id="element-2182" data-mp="1b6v0p0yg3amt">
                                  ₪{item.companionParticipant}
                                </span>
                              </div>
                              <div className="flex justify-between items-center" data-id="element-2183" data-mp="3d0u8vdg9tbva">
                                <span data-id="element-2184" data-mp="35gtd90024rsm">מלווה:</span>
                                <span className="font-semibold text-gray-900" data-id="element-2185" data-mp="30os2xjmg9b58">
                                  ₪{item.companionAddon}
                                </span>
                              </div>
                              <div className="pt-1 mt-1 border-t border-green-200 flex justify-between items-center font-bold" data-id="element-2186" data-mp="2qr3yg1z1kp9v">
                                <span className="text-green-700" data-id="element-2187" data-mp="3odktt1o7sssz">סה״כ:</span>
                                <span className="text-green-700" data-id="element-2188" data-mp="3jeqa7xifb07t">
                                  ₪{item.priceWithCompanionDisplay}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>}

                      <div className="flex flex-col gap-1 mt-auto" data-id="element-2189" data-mp="232b9ipgu7hor">
                        <span className={`text-4xl font-black ${includeCompanion ? 'text-green-600' : 'text-indigo-600'}`} data-id="element-2190" data-mp="1yywspwl2qxa9">
                          ₪
                          {includeCompanion ? item.priceWithCompanionDisplay || item.priceDisplay : item.priceDisplay}
                        </span>
                      </div>
                    </div>

                    <div className={`mt-6 pt-4 border-t border-gray-100 flex items-center justify-between text-sm font-medium ${includeCompanion ? 'text-green-600 group-hover:text-green-700' : 'text-indigo-600 group-hover:text-indigo-700'}`} data-id="element-2191" data-mp="1ia2b9z9q8o6m">
                      <span data-id="element-2192" data-mp="14a1a0ipjveqm">
                        {selectedTicketName === item.name ? 'נבחר' : 'לחצו לתשלום'}
                      </span>
                      <div className={`rounded-full p-1 transition-colors ${selectedTicketName === item.name ? includeCompanion ? 'bg-green-600 text-white' : 'bg-indigo-600 text-white' : includeCompanion ? 'bg-green-50 group-hover:bg-green-100' : 'bg-indigo-50 group-hover:bg-indigo-100'}`} data-id="element-2193" data-mp="3p09w9iia26j3">
                        <CheckCircle2 className="w-4 h-4" data-id="element-2194" data-mp="2dhuife3nph9i" />
                      </div>
                    </div>
                  </motion.div>)}
            </motion.div>

            {/* Iframe Container for Tranzila Payment */}
            <div className={`w-full bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 transition-all duration-500 ${showIframe ? 'opacity-100 max-h-[700px] mt-12' : 'opacity-0 max-h-0 overflow-hidden'}`} data-id="element-2195" data-mp="2nath5osvao6u">
              <div className="bg-gray-50 p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-2196" data-mp="316x9fck6kmgo">
                <div className="flex items-center gap-2 text-gray-600" data-id="element-2197" data-mp="12tx77bijsar9">
                  <Lock className="w-4 h-4" data-id="element-2198" data-mp="16tfj5hse5bhy" />
                  <span className="text-sm font-medium" data-id="element-2199" data-mp="16uh3ydz7lccv">
                    תשלום מאובטח באמצעות טרנזילה
                  </span>
                </div>
                <div className="text-sm font-bold text-[#0A5F8F]" data-id="element-2200" data-mp="256tiinozbcox">
                  {selectedTicketName}
                </div>
              </div>
              <iframe ref={iframeRef} name="tranzila" width="100%" height="600" frameBorder="0" allow="payment" className="w-full" data-id="element-2201" data-mp="2j3oscid21861"></iframe>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mt-8" data-id="element-2202" data-mp="2o4crjrbfsvbc">
              <Button size="lg" className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-12 py-6 rounded-full shadow-xl" onClick={() => {
              document.getElementById('pricing-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-2203" data-mp="36vdns7l6acr7">
                הרשמה לפסטיבל
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* WhatsApp Group Section */}
      <section className="py-24 bg-gradient-to-br from-green-50 to-emerald-50" data-id="element-2204" data-mp="37ouwgjz63ygy">
        <div className="container mx-auto px-4" data-id="element-2205" data-mp="3cipeliz4k5dx">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mx-auto text-center" data-id="element-2206" data-mp="2xt06t4wj134o">
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-600 px-4 py-2 rounded-full font-bold mb-6" data-id="element-2207" data-mp="2tplhfnmp7aek">
              <MessageCircle className="w-5 h-5" data-id="element-2208" data-mp="2lsbdik7shxlo" />
              <span data-id="element-2209" data-mp="2gqug4yoikt9u">הצטרפו לקהילה</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-2210" data-mp="2gtgnax7ht6rj">
              קבוצת הווטסאפ השקטה של האירוע
            </h2>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-2211" data-mp="27zlr4eocmqo1">
              הצטרפו לקבוצת הווטסאפ השקטה שלנו וקבלו עדכונים ראשונים על הפסטיבל,
              מחירים מיוחדים ופרטים חשובים
            </p>

            <motion.div whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-2212" data-mp="1xzl86tue6ckd">
              <Button size="lg" className="bg-[#25D366] hover:bg-[#20BA5A] text-white text-xl px-12 py-8 rounded-full shadow-2xl shadow-green-500/30 inline-flex items-center gap-3" onClick={() => window.open('https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA', '_blank')} data-id="element-2213" data-mp="1p0pznb3vkqdw">
                <MessageCircle className="w-6 h-6" data-id="element-2214" data-mp="1a3q3hd0bq01l" />
                הצטרפו לקבוצה
              </Button>
            </motion.div>

            <p className="mt-6 text-sm text-gray-500" data-id="element-2215" data-mp="1eydo30s7iaaw">
              קבוצה שקטה - רק עדכונים חשובים מהצוות
            </p>
          </motion.div>
        </div>
      </section>

      {/* Sponsors Section */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-2216" data-mp="r6f9a6tjtwt0">
        <div className="container mx-auto px-4" data-id="element-2217" data-mp="r6oyhs6rrzxn">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-2218" data-mp="v7imsmo4jgr2">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-2219" data-mp="2bl8u02ajil4x">
              תודה לנותני החסות
            </h3>
            <p className="text-lg text-gray-600" data-id="element-2220" data-mp="bi7m2x6jc8sj">שבזכותם כל זה לא היה קורה!</p>
          </motion.div>

          <div className="flex flex-col items-center justify-center gap-8 max-w-4xl mx-auto" data-id="element-2221" data-mp="7i5w3la5x3t3">
            {/* First Row: Focus and Super Boards */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-2222" data-mp="gilx8o3fnyus">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2223" data-mp="3oynp2qe8o7kx">
                <img src="https://cdn.magicpatterns.com/uploads/c9cqmiETssEvaaWTmgei9g/Screenshot_20260114_100258_Adobe_Acrobat~2.jpg" alt="Focus Hawaii" className="max-h-full max-w-full object-contain" data-id="element-2224" data-mp="319maeletc077" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2225" data-mp="17qvppow4xd3a">
                <img src="https://cdn.magicpatterns.com/uploads/mv2v6jUXwPZU392ZcXr96e/tempFileForShare_20260114-101156.jpg" alt="Super Boards" className="max-h-full max-w-full object-contain" data-id="element-2226" data-mp="1vfot26f36n7x" />
              </motion.div>
            </div>

            {/* Second Row: Freefull, Yamit, Zazik */}
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12" data-id="element-2227" data-mp="1ap0f06tfi2eq">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2228" data-mp="16o84la8tlrgv">
                <img src="https://cdn.magicpatterns.com/uploads/jgUGGBjF8wH9kuTWb95A31/IMG-20240320-WA0021.jpg" alt="Freefull Sea Sports" className="max-h-full max-w-full object-contain" data-id="element-2229" data-mp="1kng8uhjubprx" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2230" data-mp="28dajcsgot290">
                <img src="https://cdn.magicpatterns.com/uploads/2GpMhfwu9CXQAfHdGfWn5v/Screenshot_20260114_101728_Photos~2.jpg" alt="Yamit" className="max-h-full max-w-full object-contain" data-id="element-2231" data-mp="2yocjsakpcc35" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2232" data-mp="3dcgv2thfdlbw">
                <img src="https://cdn.magicpatterns.com/uploads/73y5FStqEUKbtd3kEz9SFX/tempFileForShare_20260114-101936.jpg" alt="Zazik" className="max-h-full max-w-full object-contain" data-id="element-2233" data-mp="j1buh8ufr9mm" />
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} className="flex items-center justify-center w-32 h-24 md:w-40 md:h-28" data-id="element-2234" data-mp="1gmr336t8d286">
                <img src="https://cdn.magicpatterns.com/uploads/npk7YuYBA3fqzgJiMFKPp9/sk_logo_01.jpg" alt="SK Surf Boards" className="max-h-full max-w-full object-contain" data-id="element-2235" data-mp="3k3noihlzapfd" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-2236" data-mp="3ow7bg56k2wwu" />
      <WaterTribeFestTicketSelection isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-2237" data-mp="3oxrwn46zd3i1" />
      <WaterTribeFestPrePaymentForm isOpen={showPrePaymentForm} onClose={() => setShowPrePaymentForm(false)} onSubmit={handlePrePaymentFormSubmit} ticketName={pendingTicket?.name || ''} ticketPrice={pendingTicket?.priceDisplay || ''} ticketType={pendingTicket?.ticketType} data-id="element-2238" data-mp="2w7036ehausye" />
    </div>;
}